import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import {
  SelectField,
  TextField,
  Toggle,
  AutoComplete,
} from "redux-form-material-ui";
import { connect } from "react-redux";
import MenuItem from "material-ui/MenuItem";
import { AutoComplete as MUIAutoComplete } from "material-ui";
import Fab from "material-ui/FloatingActionButton";
import Check from "material-ui/svg-icons/navigation/check";
import RaisedButton from "material-ui/RaisedButton";

import { required, multipleEmails } from "../services/form";

import { getKindPrimaryText } from "../utils";
import { merchantInfoUpdate, loadResorts, loadMerchantList } from "./actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";
import Token from "../services/token";
import { withConfiguration } from "../services/config";
import AdminLink from "../app/AdminLink";

class Detail extends Component {
  state = {
    search: "",
  };

  componentDidMount() {
    this.refs.name.getRenderedComponent().getRenderedComponent().focus();
    this.props.loadResorts();
    this.props.loadMerchantList();
  }

  handleUpdateInput = (current, merchants) => {
    this.setState({ search: current });
  };

  openStandardProduct = () => {
    const { initialValues } = this.props;
    const values = this.props.formValues();
    if (
      (initialValues.kind === "SKI_RENTAL" || initialValues.kind === "STAND") &&
      (values.kind === "SKI_RENTAL" || values.kind === "STAND") &&
      initialValues.kind === values.kind
    )
      window.open(
        `${withConfiguration(
          (config) => config["standardproduct-server"]
        )}?token=${Token.read()}&merchant=${values && values.code}&kind=${
          values && values.kind
        }&name=${values && values.libelle}&resort=${
          values && values.mainResort
        }`,
        "standardproduct"
      );
  };

  render() {
    const {
      handleSubmit,
      user,
      resorts,
      merchantList,
      initialValues,
    } = this.props;
    const values = this.props.formValues();
    const merchantGroupList = [
      { value: "", text: "" },
      ...merchantList.map((merchant) => {
        return {
          value: merchant.code,
          text: merchant.libelle.replace("Remontées Mécaniques", "RM"),
        };
      }),
    ];
    const { msem } = initialValues;
    const isNotESF = values.kind !== "ESF";
    const canEditEmail = checkPrivileges(
      user.privileges,
      auth.MERCHANT_EDIT_EMAIL_FIELD
    );
    const isNotASSU = values.kind !== "ASSU";
    const displayEmailFields = isNotESF || canEditEmail || isNotASSU;
    return (
      <div className="card-container">
        <div className="card">
          {" "}
          <div className="title">Paramètres ESF+</div>
          <div className="inner">
            {msem ? (
              <RaisedButton
                href={msem}
                target="_blank"
                label="mon séjour en montagne"
                primary
              />
            ) : null}
            <form onSubmit={handleSubmit}>
              <div className="fieldset">
                <Field
                  name="libelle"
                  floatingLabelText="Nom"
                  component={TextField}
                  validate={required}
                  ref="name"
                  withRef
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_NAME_FIELD
                    )
                  }
                />
                <Field
                  name="kind"
                  floatingLabelText="Type de marchand"
                  component={SelectField}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_KIND_FIELD
                    )
                  }
                  onChange={this.changeKind}
                  validate={required}
                >
                  <MenuItem />
                  <MenuItem
                    value="ESF"
                    primaryText={getKindPrimaryText("ESF")}
                  />
                  <MenuItem
                    value="LIFT"
                    primaryText={getKindPrimaryText("LIFT")}
                  />
                  <MenuItem
                    value="ASSU"
                    primaryText={getKindPrimaryText("ASSU")}
                  />
                  <MenuItem
                    value="HOT"
                    primaryText={getKindPrimaryText("HOT")}
                  />
                  <MenuItem
                    value="TOURIST_TAX"
                    primaryText={getKindPrimaryText("TOURIST_TAX")}
                  />
                  <MenuItem
                    value="STAND"
                    primaryText={getKindPrimaryText("STAND")}
                  />
                  <MenuItem
                    value="SKI_RENTAL"
                    primaryText={getKindPrimaryText("SKI_RENTAL")}
                  />
                </Field>
              </div>
              <div className="fieldset">
                <Field
                  name="code"
                  floatingLabelText="Code marchand"
                  component={TextField}
                  validate={required}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_CODE_FIELD
                    )
                  }
                />
                {checkPrivileges(
                  user.privileges,
                  auth.MERCHANT_EDIT_MAIN_RESORT_FIELD
                ) ? (
                  <Field
                    name="mainResort"
                    floatingLabelText="Station principale"
                    component={SelectField}
                  >
                    <MenuItem value={null} primaryText={""} />
                    {resorts.map((resort) => (
                      <MenuItem
                        key={resort.id}
                        value={resort.id}
                        primaryText={resort.libelle}
                      />
                    ))}
                  </Field>
                ) : (
                  <div className="field-spacer" />
                )}
              </div>
              <div className="fieldset">
                <Field
                  name="sm_appuserid"
                  floatingLabelText="SMoney AppUserID"
                  component={TextField}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_APPUSERID_FIELD
                    )
                  }
                />
                <Field
                  name="sm_appaccountid"
                  floatingLabelText="SMoney AppAccountID"
                  component={TextField}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_APPACCOUNTID_FIELD
                    )
                  }
                />
              </div>
              <div className="fieldset">
                <Field
                  name="facet"
                  floatingLabelText="Mode"
                  component={SelectField}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_FACET_FIELD
                    )
                  }
                >
                  <MenuItem value={0} primaryText="Hiver" />
                  <MenuItem value={1} primaryText="Été" />
                  <MenuItem value={2} primaryText="Toutes saisons" />
                </Field>
                {checkPrivileges(
                  user.privileges,
                  auth.MERCHANT_EDIT_MERCHANT_GROUP_FIELD
                ) ? (
                  <Field
                    name="merchant_group"
                    component={AutoComplete}
                    listStyle={{
                      width: "300px",
                      maxHeight: "200px",
                      overflow: "auto",
                    }}
                    floatingLabelText="Méta-marchand"
                    openOnFocus
                    filter={MUIAutoComplete.caseInsensitiveFilter}
                    dataSourceConfig={{ text: "text", value: "value" }}
                    dataSource={merchantGroupList}
                    searchText={""}
                  />
                ) : (
                  <div className="field-spacer" />
                )}
              </div>
              {displayEmailFields ? (
                <div className="fieldset">
                  {isNotESF || canEditEmail ? (
                    <Field
                      name="email"
                      floatingLabelText="Email confirmation de commande"
                      component={TextField}
                      validate={multipleEmails}
                    />
                  ) : null}
                  {isNotASSU ? (
                    <Field
                      name="send_merchant_email"
                      label="En copie des emails de confirmation"
                      labelPosition="left"
                      className="send-merchant-email-toggle"
                      component={Toggle}
                    />
                  ) : null}
                  {!(isNotESF || canEditEmail) || !isNotASSU ? (
                    <div className="field-spacer" />
                  ) : null}
                </div>
              ) : null}
              {values.kind !== "ESF" ? (
                <div>
                  <Field
                    name="email_comment_fr"
                    floatingLabelFixed
                    floatingLabelText="Texte mail de confirmation en français"
                    textareaStyle={{ backgroundColor: "#fafafa" }}
                    fullWidth
                    multiLine
                    rows={3}
                    component={TextField}
                  />
                  <Field
                    name="email_comment_en"
                    floatingLabelFixed
                    floatingLabelText="Texte mail de confirmation en anglais"
                    textareaStyle={{ backgroundColor: "#fafafa" }}
                    fullWidth
                    multiLine
                    rows={3}
                    component={TextField}
                  />
                </div>
              ) : null}
              {checkPrivileges(
                user.privileges,
                auth.MERCHANT_EDIT_NOTES_FIELD
              ) ? (
                <Field
                  name="notes"
                  floatingLabelFixed
                  floatingLabelText="Notes"
                  textareaStyle={{ backgroundColor: "#ffffcc" }}
                  fullWidth
                  multiLine
                  rows={3}
                  component={TextField}
                />
              ) : null}
              {(initialValues.kind === "SKI_RENTAL" ||
                initialValues.kind === "STAND") &&
              (values.kind === "SKI_RENTAL" || values.kind === "STAND") &&
              initialValues.kind === values.kind ? (
                <div>
                  <RaisedButton
                    className="standard-product"
                    label="Administration des produits"
                    secondary
                    onClick={this.openStandardProduct}
                    disabled
                  />
                  <AdminLink />
                </div>
              ) : null}
              <Fab type="submit" className="fab" secondary>
                <Check />
              </Fab>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Detail = reduxForm({
  form: "Detail",
  enableReinitialize: true,
})(Detail);

/********* Container part */

const mapStateToProps = (state) => ({
  initialValues: state.merchant.detail,
  user: state.app.auth.user,
  formValues: () => (state.form.Detail ? state.form.Detail.values : {}),
  resorts: state.merchant.resorts,
  merchantList: state.merchant.merchantList,
});

const mapDispatchToProps = (dispatch, getState) => ({
  onSubmit: (values) => {
    const {
      code,
      sm_appaccountid,
      sm_appuserid,
      kind,
      libelle,
      mainResort,
      email,
      email_comment_fr,
      email_comment_en,
      notes,
      send_merchant_email,
      merchant_group,
      facet,
    } = values;
    dispatch(
      merchantInfoUpdate(
        code,
        sm_appaccountid,
        sm_appuserid,
        kind,
        libelle,
        mainResort,
        email,
        email_comment_fr,
        email_comment_en,
        notes,
        send_merchant_email,
        merchant_group,
        facet
      )
    );
  },
  loadResorts: () => dispatch(loadResorts()),
  loadMerchantList: () => dispatch(loadMerchantList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Detail);



// WEBPACK FOOTER //
// ./src/merchant/Detail.js